export default __webpack_public_path__ + "static/media/book7.0db43ab3.jpeg";